import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { DisputeFilter } from "../../../data/clearing/dispute/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const DisputeFilterChipsComponent: React.FunctionComponent<DisputeFilterChipsProps> = ({
  filter,
  removeFilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);
  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("dateto")}
          />
        </Grid>
      )}
      {filter.product && (
        <Grid item>
          <Chip
            label={`${getString("dlvrproductName")}: ${filter.product.prodName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("product")}
          />
        </Grid>
      )}
      {filter.client && (
        <Grid item>
          <Chip
            label={`${getString("paymentClientName")}: ${filter.client.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("client")}
          />
        </Grid>
      )}
      {filter.buyer && (
        <Grid item>
          <Chip
            label={`${getString("disbuyerName")}: ${filter.buyer.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("buyer")}
          />
        </Grid>
      )}
      {filter.seller && (
        <Grid item>
          <Chip
            label={`${getString("dissellerName")}: ${filter.seller.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("seller")}
          />
        </Grid>
      )}

    </Grid>
  );
};

interface DisputeFilterChipsProps {
  filter: DisputeFilter;
  removeFilter: (type: keyof DisputeFilter) => void;
}
